import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Group } from 'src/app/models/group.model';
import { TempGroup } from 'src/app/models/tempgroup.model';
import { Unit } from 'src/app/models/unit.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GroupService {

  baseUrl: string = environment.apiUrl

  constructor(private http: HttpClient) { }

  retrieveGroupPlant(id: number): Observable<Group[]> {
    return this.http.get<Group[]>(this.baseUrl + '/group/plant/' + id)
  }

  retrieveActiveGroupPlant(id:number):Observable<Group[]>{
    return this.http.get<Group[]>(this.baseUrl + '/group/plant/active/' + id);
  }

  retrieveTempGroupPlant(id: number): Observable<TempGroup[]> {
    return this.http.get<TempGroup[]>(this.baseUrl + '/TempUserGroup/plant/' + id)
  }

  retrieveActiveTempGroupPlant(id:number):Observable<TempGroup[]>{
    return this.http.get<TempGroup[]>(this.baseUrl + '/TempUserGroup/plant/active/' + id)
  }

  retrieveGroupPlantPaginated(id: number, pageNumber: number, pageSize: number): Observable<Group[]> {
    return this.http.get<Group[]>(`${this.baseUrl}/group/plant/${id}/${pageNumber}/${pageSize}`)
  }

  retrieveTempGroupPlantPaginated(id: number, pageNumber: number, pageSize: number): Observable<TempGroup[]> {
    return this.http.get<TempGroup[]>(`${this.baseUrl}/tempUserGroup/plant/${id}/${pageNumber}/${pageSize}`)
  }

  addGroup(item: Group): Observable<Group> {
    return this.http.post<Group>(this.baseUrl + '/userGroup', item)
  }

  addTempGroup(item: TempGroup): Observable<TempGroup> {
    return this.http.post<TempGroup>(this.baseUrl + "/tempUserGroup", item);
  }

  deactivateGroup(id: number): Observable<Group> {
    return this.http.patch<Group>(this.baseUrl + '/group/deactivate/' + id, {})
  }

  deactivateTempGroup(id: number): Observable<Group> {
    return this.http.patch<Group>(this.baseUrl + '/tempUserGroup/deactivate/' + id, {})
  }

}
